<app-main-layout>
  <app-kanban-page></app-kanban-page>
</app-main-layout>
